module.exports = __webpack_public_path__ + "static/logo-34a7ec728fb315ef5960645987845149.svg";